<script>
  import { Block } from '@reuters-graphics/graphics-components';
  import { assets } from '$app/paths';
  import { lerp } from './utils';
  import P10TrafficMinimap from '$lib/ai2svelte/p10_traffic_minimap.svelte';

  let { note, source } = $props();

  let currentTime = $state(0);
  let videoDuration = $state(1);
  let startEpoch = 1772150400000;
  let endEpoch = 1772588805000;

  function formatAPStyle(date) {
    const days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    const months = [
      'Jan.',
      'Feb.',
      'March',
      'April',
      'May',
      'June',
      'July',
      'Aug.',
      'Sept.',
      'Oct.',
      'Nov.',
      'Dec.',
    ];

    const day = days[date.getUTCDay()];
    const month = months[date.getUTCMonth()];
    const dateNum = date.getUTCDate();
    // const year = date.getUTCFullYear();

    let hours = date.getUTCHours();
    // const minutes = Math.floor(date.getUTCMinutes() / 5) * 5;
    const period = hours >= 12 ? 'p.m.' : 'a.m.';

    hours = hours % 12;
    if (hours === 0) hours = 12;

    // const minutesStr = minutes.toString().padStart(2, '0');

    return `${day}, ${month} ${dateNum}, ${hours} ${period} GMT`;
  }

  let actualTime = $derived(
    formatAPStyle(
      new Date(lerp(currentTime, 0, videoDuration, startEpoch, endEpoch))
    )
  );
</script>

<Block width="wide" id="traffic-video-block">
  <video
    src={`${assets}/videos/strait-traffic.mp4`}
    autoplay
    loop
    muted
    playsinline
    bind:currentTime
    bind:duration={videoDuration}
  ></video>
  <p id="video-time" class="font-sans text-sm">{actualTime}</p>
  <div id="minimap">
    <P10TrafficMinimap assetsPath={assets || '/'} />
  </div>
  <p class="note">{note}</p>
  <p class="note">{source}</p>
</Block>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  video {
    width: 100%;
    object-fit: cover;

    @media (max-width: 520px) {
      aspect-ratio: 1;
    }
  }

  :global(#traffic-video-block) {
    position: relative;
  }

  #video-time {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 4px 8px;
    font-variant: tabular-nums;
  }

  #minimap {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 240px;
    // aspect-ratio: 3/2;
    border: 1px solid #ccc;
    border-radius: 2px;
    overflow: hidden;

    @media (max-width: 767px) {
      display: none;
    }
  }

  .note {
    font-family: var(--theme-font-family-note);
    color: var(--theme-colour-text-secondary);
    font-size: var(--theme-font-size-xs);
    line-height: 1.3;
    font-weight: 400;
    padding: 0;
    margin: 0;
  }
</style>
